import {usePermitExtensionsTable} from "permitextension/data";
import {SectionCard} from "base/ui/section/components";
import {SimpleTable} from "base/table/components";
import {NoDataContainer} from "base/shared/components";

const ApprovedPermitExtensionsSection = ({extensions, secondaryAction = null}) => {
    const {tableColumnsSummary} = usePermitExtensionsTable();

    return (
        <SectionCard title="Prorrogação" secondaryAction={secondaryAction}>
            {extensions.length ? (
                <SimpleTable dataRows={extensions} tableColumns={tableColumnsSummary} />
            ) : (
                <NoDataContainer text="Esta autorização não tem prorrogação." />
            )}
        </SectionCard>
    );
};

export default ApprovedPermitExtensionsSection;
